export const displayValue = (val, options = {}) => {
  const {
    prefix = "",
    suffix = "",
    fallback = "-",
    zeroAllowed = true,
    formatFn = null, // Optional formatter like formatPrice
  } = options;

  // Handle completely missing values
  if (val === undefined || val === null || val === "") return fallback;

  // Clean commas if value is a numeric string (e.g. "50,000.00")
  let numericVal = val;
  if (typeof val === "string" && val.trim() !== "") {
    numericVal = val.replace(/,/g, ""); // remove commas
    if (!isNaN(numericVal)) numericVal = Number(numericVal);
  }

  // Apply format function if provided (like formatPrice)
  const formattedVal = formatFn ? formatFn(numericVal) : numericVal;

  // Handle emptiness after formatting
  const isEmpty =
    formattedVal === undefined ||
    formattedVal === null ||
    (!zeroAllowed && Number(formattedVal) === 0) ||
    (typeof formattedVal === "string" && formattedVal.trim() === "");

  return isEmpty ? fallback : `${prefix}${formattedVal}${suffix}`;
};
  